export class Controller {

    /** @ngInject */
    constructor(
        $state,
        $uibModal,
        Account,
        Alert,
        PasswordAuthenticationPoliciesService,) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Account = Account;
        this.Alert = Alert;
        this.PasswordAuthenticationPoliciesService = PasswordAuthenticationPoliciesService;
    }

    $onInit() {
        this.companyId = this.$state.params.companyId;
    }

    removePolicy(applicationId){
        this.PasswordAuthenticationPoliciesService.removePasswordPolicyFromApplication(this.companyId,this.policy.passwordPolicyId,applicationId)
            .then(()=>this.$state.reload('company.policies.password-authentication-policy'))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.manage.unassigned'))
            .finally(() => (this.isSaving = null));
    }

    assignPolicytoApp(applicationId){
        this.PasswordAuthenticationPoliciesService.applyPasswordPolicyToApplication(this.companyId,this.policy.passwordPolicyId,applicationId)
            .then(()=>this.$state.reload('company.policies.password-authentication-policy'))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.manage.assigned'))
            .finally(() => (this.isSaving = null));
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/policies/password-authentication-policy/assign-application/assign-application.controller.js